import * as React from 'react';
import TopNavigation from '../sitefinity/top-navigation/top-navigation';
import { LocationContext } from '../../hooks/location';
import * as styles from './sitefinity-layout.module.scss';
import Footer from '../sitefinity/footer/footer';
import classNames from '../../utilities/class-names';
import SfSideNav from '../sitefinity/side-nav/side-nav';
import { CurrentNavSegmentsContext, useNavMap } from '../../hooks/current-nav-segments';
import SfBreadcrumb from '../sitefinity/breadcrumb/breadcrumb';
import SfToc from '../sitefinity/toc/toc';
import { PageDataContext } from '../../hooks/page-data';
import { PageContextMapProvider } from '../../hooks/page-context-map';
import { usePageContexts } from '../../queries/page-contexts';
import GoogleTagManager from '../google-tag-manager/google-tag-manager';
import AnnouncementBanner from '../announcement-banner/announcement-banner';
import { AiStarsGradient } from '../icons/ai-stars';

const SitefinityLayout = ({ children, location, data }) => {
    const navMap = useNavMap();
    const pageContexts = usePageContexts();
    const [bannerHeight, setBannerHeight] = React.useState(0);

    React.useEffect(() => {
        document.documentElement.style.setProperty('--banner-height', `${bannerHeight}px`);
        return () => document.documentElement.style.removeProperty('--banner-height');
    }, [bannerHeight]);

    const pageContextMap = React.useMemo(() => {
        const result = {
            pathMap: {},
            slugMap: {}
        };

        pageContexts.allSitePage.nodes.forEach(n => {
            result.pathMap[n.path] = n.pageContext;

            if (n.pageContext?.slug) {
                result.slugMap[n.pageContext.slug] = n.path;
            }
        });

        return result;
    }, [pageContexts]);

    const aiChatPage = React.useMemo(() => {
        const result = data?.aiChatPage || false;
        return result;
    }, [data]);

    const fullScreen = React.useMemo(() => {
        const result = data?.notFoundPage || data?.searchPage || data?.tagsPage || data?.aiChatPage || false;
        return result;
    }, [data]);

    const currentNavSegments = React.useMemo(() => {
        const pathname = location.pathname.replace(/\/+$/, '') || '/';
        return navMap[pathname] || [];
    }, [navMap, location]);

    const hideToc = React.useMemo(() => data?.markdownRemark?.fields?.hideToc || false, [data]);

    return (<>
        <PageContextMapProvider value={pageContextMap}>
            <PageDataContext.Provider value={data}>
                <CurrentNavSegmentsContext.Provider value={currentNavSegments}>
                    <LocationContext.Provider value={location}>
                        <GoogleTagManager />
                        <AiStarsGradient></AiStarsGradient>
                        <AnnouncementBanner bannerHeightChanged={setBannerHeight} />
                        <TopNavigation hideMobileMenu={!!fullScreen} />
                        <div className={classNames(styles.appBody, 'template-sitefinity')}>
                            <div className={classNames(styles.mainContainer, 'd-flex', 'flex-column', 'e2e-sf-main-container')}>
                                <div className={classNames(hideToc && styles.hideToc, fullScreen && styles.fullScreen, `row`, `no-gutters`, `flex-grow-1`)}>
                                    <div className={classNames('col-3', styles.navCol)}>
                                        <SfSideNav />
                                    </div>
                                    <div className={classNames(fullScreen ? 'col-12' : 'col-9', styles.contentCol)} style={{padding: aiChatPage ? 0 : null}}>
                                        <div className={classNames('e2e-content', styles.content)}>
                                            <SfBreadcrumb />
                                            {children}
                                        </div>
                                        <div className={styles.tocContainer}>
                                            <SfToc />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.footerWrap}>
                                <Footer />
                            </div>
                        </div>
                    </LocationContext.Provider>
                </CurrentNavSegmentsContext.Provider>
            </PageDataContext.Provider>
        </PageContextMapProvider>
    </>)
}

export default SitefinityLayout;